import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppToast } from '@ui-seeker/app'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import {
    selectedSku,
    skuDetailData,
    isLoading,
    selectedDays
} from '../@signals'

// Standalone fetch function (can be called from anywhere)
export function fetchSkuDetail(idSku, days, showToast) {
    if (!idSku) {
        skuDetailData.value = null
        return
    }

    isLoading.value = true
    getSubmit(`${BACKEND_APIS.SKU_MANAGEMENT}/detail?id_sku=${idSku}&days=${days || 7}`)
        .then(res => {
            skuDetailData.value = res
        })
        .catch(err => {
            console.error('Error fetching SKU detail:', err)
            showToast?.error?.('Error loading SKU details')
            skuDetailData.value = null
        })
        .finally(() => {
            isLoading.value = false
        })
}

export default function usePriceAnalysis() {
    const { showToast } = useAppToast()
    const [searchParams] = useSearchParams()
    const initialLoadDone = useRef(false)

    // Load SKU from URL param on mount (only once)
    useEffect(() => {
        if (initialLoadDone.current) return
        initialLoadDone.current = true

        const idSkuParam = searchParams.get('id_sku')
        if (idSkuParam) {
            getSubmit(`${BACKEND_APIS.AUDIT_LOG}/skus?selected=${idSkuParam}`)
                .then(res => {
                    if (res?.length > 0) {
                        selectedSku.value = res[0]
                        fetchSkuDetail(res[0].value, selectedDays.value, showToast)
                    }
                })
                .catch(console.error)
        }
    }, [])

    return {
        fetchSkuDetail: (idSku, days) => fetchSkuDetail(idSku, days, showToast),
        showToast
    }
}
